import { VHeaders } from '@/models/pagedlistmodel';

export function getTemplateListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('templates.templateGridHeaders.name') as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'templates.templateGridHeaders.description'
      ) as string,
      align: 'left',
      value: 'text',
      sortable: true,
    },
    {
      text: vm.$parent.$t('templates.templateGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
